/**
 * `/portal/messages/popout/:threadId`: the pop-out window's standalone view (a pop-out that
 * was reloaded or opened by URL). It covers the shell so the window shows only the thread and
 * syncs read markers, drafts and new messages with the other windows through the channel.
 */
import { ThreadView } from '../components/thread-view';
import { useSyncInvalidation } from '../sync';

export function PopoutThread({ threadId, onClose }: { threadId: string; onClose?: () => void }) {
  useSyncInvalidation();
  return (
    <div data-popout={threadId} className="flex h-dvh flex-col bg-background p-3 text-foreground">
      <ThreadView threadId={threadId} popout={false} {...(onClose ? { onClose } : {})} />
    </div>
  );
}

export function PopoutPage({ threadId }: { threadId: string }) {
  return (
    <div className="fixed inset-0 z-50 bg-background">
      <PopoutThread threadId={threadId} />
    </div>
  );
}
